module.exports = __webpack_public_path__ + "static/media/fruits-secs.e0ac1baf.svg";